
    <!--
 * 竖版-首充领奖
 * @LastEditTime: Tue Dec 17 2024 15:43:17 GMT+0800 (中国标准时间)
 -->
 <template>
  <div id="u_c_113F49"  :class="[`normal`,`u_c_113F49`]" ><div id="u_c_EZY950"  :class="[`${ compData.title ? 'text' : '' }`,`normal `,`u_c_EZY950`]" ><div id="u_c_9ETL51"  v-html="compData.title" :class="[`normal`,`u_c_9ETL51`]" ></div></div><div id="u_c_4Y2C52"  v-html="compData.subTitle" :class="[`normal`,`u_c_4Y2C52`]" ></div><div id="u_c_94ZU53"  :style="`background-image:url(${ compData.giftIcon })`" :class="[`normal`,`u_c_94ZU53`]" ></div><a id="u_c_GVOB54" href="javascript:;" :style="`background-image:url(${ pageData['common-btn-bg'] })`" :class="[`${ pageData.firstPayState == 2 && pageData.firstPayType != 'sendCoupon' ? 'has' : 'btn-light' }`,`normal  `,`u_c_GVOB54`]" @click="u_c_GVOB54_event_NP9I65($event)"><div id="u_c_HGYQ55"  :class="[`normal page-common-btn`,`u_c_HGYQ55`]" ><div id="u_c_67AJ56"  v-show="pageData.firstPayState != 2" :class="[`normal `,`u_c_67AJ56`]" >{{`${ langData.getBtn }`}}</div><div id="u_c_2F1C58"  v-show="pageData.firstPayState == 2 && pageData.firstPayType != 'sendCoupon'" :class="[`normal `,`u_c_2F1C58`]" >{{`${ langData.hasBtn }`}}</div><div id="u_c_471C60"  v-show="pageData.firstPayState == 2 && pageData.firstPayType == 'sendCoupon'" :class="[`normal `,`u_c_471C60`]" >{{`${ langData.useBtn }`}}</div></div></a></div>
  </template>
<script setup>
import {reactive,provide,inject,onMounted,watch,watchEffect,ref,computed,nextTick,readonly,toRaw,markRaw} from "vue";
import * as vueUse from "@vueuse/core";
import Language from "@/hooks/language.js";
import Router from "@/hooks/router.js";
import bridge from "@/utils/sdkBridge.js";
import { useRoute } from 'vue-router';
import * as request from "@/api/request";
import * as utils from "@/utils";
import * as _ from "lodash-es";


    const { curLang, getLangTxt,langData } = Language();
    const routerData = inject("routerData",{});
    const pageData = inject("pageData", {});
    const COMP_DATA_LANG = {"default":{"subTitle":`活动期间，通过官网渠道成功储值任意金额即可领取xxxxxx`,"giftIcon":`https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129661162484752.png`,"giftName":`首储礼包`,"title":`成神归来
每日赠礼`},"zh-CN":{"subTitle":`活动期间，通过【官网储值页面】任意渠道成功储值任意金额，即可领取奖励，每个账号只能领取一次；`,"giftIcon":`https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129661162484752.png`,"giftName":`钻石 *200
小型资源补给箱 *2
强化选择补给箱 *5
加速60分钟 *5`,"title":`超值首储赠好礼`},"zh-TW":{"subTitle":`活動期間，通過【官網儲值頁面】任意管道成功儲值任意金額，即可領取獎勵，每個帳號只能領取一次；`,"giftIcon":`https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129661162484752.png`,"giftName":`鑽石 *200
小型資源補給箱 *2
強化選擇補給箱 *5
加速60分鐘 *5`,"title":`超值首儲贈好禮`},"en-US":{"subTitle":`During the event, top up on Puzzles & Survival's official website to obtain a reward. The reward can only be claimed once per account.`,"giftIcon":`https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129661162484752.png`,"giftName":`Diamond *200
Lesser Resource Box *2
Enhance Choice Box *5
60-min Speedup *5`,"title":`1st Top-up Reward`},"ja-JP":{"subTitle":`イベント期間中、「公式チャージ画面」にて任意の決済方法で任意の金額をチャージすると、ボーナスを受け取れます！（1つのアカウントにつき1回のみ）`,"giftIcon":`https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129661162484752.png`,"giftName":`ダイヤ *200
小型資源補給 *2
選択型強化補給 *5
ブースト（60分間） *5`,"title":`初回チャージギフトGET`},"ko-KR":{"subTitle":`이벤트 기간에 공식 결제 플랫폼에서 금액 관계 없이 충전만 하면 보상을 획득합니다. (계정당 한 번만 가능!)`,"giftIcon":`https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129661162484752.png`,"giftName":`다이아 *200
소형 자원 보급 상자 *2
강화 선택 보급상자 *5
60분 가속 *5`,"title":`혜택 가득 첫 충전`},"th-TH":{"subTitle":`ช่วงกิจกรรม เพียงเติมเงินผ่าน [หน้าเพจเว็บไซต์ทางการ] สำเร็จ ก็สามารถรับรางวัลได้ (รับได้บัญชีละ 1 ครั้ง)`,"giftIcon":`https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129661162484752.png`,"giftName":`เพชร *200
หีบทรัพยากรไซส์มินิ *2
หีบเลือกตีบวก *5
เร่งสปีด60นาที *5`,"title":`รางวัลเติมเงินครั้งแรกสุดคุ้ม`},"vi-VN":{"subTitle":`Trong thời gian hoạt động, nạp mức bất kỳ trên kênh bất kỳ là có thưởng, mỗi tài khoản chỉ được lấy một lần;`,"giftIcon":`https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129661162484752.png`,"giftName":`Kim Cương *200
Rương Tài Nguyên Nhỏ *2
Rương Chọn Cường Hoá *5
Tăng tốc 60 phút *5`,"title":`Quà nạp đầu siêu giá trị`},"de-DE":{"subTitle":`Lade während des Events auf der offiziellen Webseite von Puzzles & Survival auf, um eine Belohnung zu erhalten. Die Belohnung kann nur einmal pro Konto abgeholt werden.`,"giftIcon":`https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129661162484752.png`,"giftName":`Diamant *200
Kleine Ressource Kiste *2
Verbessern Auswahlkiste *5
60 Min Beschleunigen *5`,"title":`1. Aufladebelohnung`},"fr-FR":{"subTitle":`Pendant l'événement, rechargez votre compte sur le site officiel de Puzzles & Survival pour obtenir une récompense. La récompense ne peut être réclamée qu'une fois par compte.`,"giftIcon":`https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129661162484752.png`,"giftName":`Diamant *200
Petite boîte ressources *2
Boîte de renforcement au choix *5
Accélération 60-min *5`,"title":`Récompense de 1ère Recharge`},"ru-RU":{"subTitle":`Пополните счёт на официальном сайте «Puzzles & Survival» во время события и получите награду. Такой приз можно получить лишь раз.`,"giftIcon":`https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129661162484752.png`,"giftName":`Алмаз *200
Малый Ящик с Ресурсами *2
Ящик с Улучшениями на Выбор *5
Ускорение (60 мин.) *5`,"title":`Награда за 1-е Пополнение`},"es-ES":{"subTitle":`Durante el evento, haz una recarga en el sitio web oficial de Puzzles & Survival para obtener una recompensa. La recompensa solo se puede reclamar una vez por cuenta.`,"giftIcon":`https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129661162484752.png`,"giftName":`Diamante *200
Caja de Recursos Inferior *2
Mejora la Caja de Elección *5
Aceleración de 60 min *5`,"title":`Recompensa de la 1.ª recarga`},"pt-PT":{"subTitle":`Durante o evento, faça uma recarga no site oficial do Puzzles & Survival para obter uma recompensa. A recompensa só pode ser resgatada uma vez por conta.`,"giftIcon":`https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129661162484752.png`,"giftName":`Diamante *200
Caixa Menor de Recursos *2
Caixa da Escolha de Melhorias *5
Aceleração de 60 minutos *5`,"title":`1ª Recompensa de Recarga`},"it-IT":{"subTitle":`Durante l'evento, ricarica sul sito ufficiale di Puzzles & Survival per ottenere una ricompensa. Il premio può essere richiesto solo una volta per account.`,"giftIcon":`https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129661162484752.png`,"giftName":`Diamante *200
Scatola Risorse Minore *2
Scatola Scelta Migliora *5
Velocizz. 60-min *5`,"title":`Ricompensa 1ma Ricarica`},"tr-TR":{"subTitle":`Etkinlikte bir ödül almak için Puzzles & Survival'ın resmi sitesinde yükleme yap. Her hesap başına yalnızca bir kez ödül talep edilebilir.`,"giftIcon":`https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129661162484752.png`,"giftName":`Elmas *200
Küçük Kaynak Kutusu *2
Büyütme Seçimi Kutusu *5
60-dk Hızlandırma *5`,"title":`1. Yükleme Ödülü`},"pl-PL":{"subTitle":`Podczas wydarzenia doładuj konto na oficjalnej stronie Puzzles & Survival, aby otrzymać nagrodę. Nagroda może być odebrana tylko raz na jedno konto.`,"giftIcon":`https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129661162484752.png`,"giftName":`Diament *200
Mniejsze Pudełko z Zasobami *2
Pudło Wyboru Wzmocnienia *5
60-min. Przyśpieszenie *5`,"title":`Nagroda 1wszego doładowania`},"id-ID":{"subTitle":`Laad tijdens het event op via de officiële website van Puzzles & Survival om een beloning te krijgen. De beloning kan slechts eenmaal per account worden geclaimd.`,"giftIcon":`https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129661162484752.png`,"giftName":`Diamond *200
Small Resource Supply Box *2
Enhance Choice Supply Box *5
Speed up 60 menit *5`,"title":`1e Oplaad Beloning`},"ar-SA":{"subTitle":`Selama Event, lakukan Top Up berapa pun dan dengan cara pembayaran apa pun untuk klaim hadiah. Setiap akun hanya bisa klaim 1x.`,"giftIcon":`https://cdnimages.awselbcombine.com/public_images/one_image/2024/07/172129661162484752.png`,"giftName":`200* الماس
2* صندوق الموارد الصغير
5* اختيار صندوق الإمدادات
5* تسريع 60 دقيقة`,"title":`Hadiah Top Up Perdana Berharga`}};
    const compData = reactive(COMP_DATA_LANG[curLang] || COMP_DATA_LANG['en-US']||{});
    let pagePlatform = "global"
    const router = Router();
    const route = useRoute();
    const compName = '首充领奖';

    // 自定义setup - 开始
    const checkIsBind = inject("checkIsBind", () => {})
const checkIsLogin = inject("checkIsLogin", () => {})
const listData = inject("listData", {})
const showTips = inject("showTips", (txt, code) => {})
const showGetSucc = inject("showGetSucc", (type, pic, name) => {})
const giftInfo = inject("giftInfo", {})
const getCurLink = inject("getCurLink", (link) => {})

giftInfo.firstPayAward = [{ name: compData.giftName }]
const curPlatform = pagePlatform;
const canClick = ref(true)


const getFirstGift = async () => {
  const link = {
    gm99: `https://eventsapi.gm99.com/activity/execute?name=${pageData.pageId}&action=firstPayAward`,
    global: `https://gactivityapi.${utils.getMainHost()}/activity/execute?name=${
      pageData.pageId
    }&action=firstPayAward`,
    omnion: `https://gactivityapi.${utils.getMainHost()}/activity/execute?name=${
      pageData.pageId
    }&action=firstPayAward`,
  }
  let res = await request.getJSON(link[curPlatform], {
    params: JSON.stringify({
      language: curLang,
    }),
  })
  if (res.result == 1) {
    pageData.firstPayState = 2
    let curGiftName = pageData.firstPayType == 'sendSerial' ?res.data.send_value :compData.giftName
    showGetSucc(pageData.firstPayType, compData.giftIcon, curGiftName)
  } else {
    showTips(getLangTxt(res.code, getLangTxt("common")), res.code)
  }
  return res.result == 1
}

;
      // 领取按钮的click事件
      const u_c_GVOB54_event_NP9I65= async (e)=>{
        try {if (!checkIsLogin()) return;
if (!checkIsBind()) return;
if (+pageData.firstPayState > 1) {
  if (pageData.firstPayType == 'sendCoupon') {
    window.activityDataLayer.push({
      eventName: 'click_button',
      eventType: '前往使用优惠券',
      gameId: pageData.gameId,
      aid: pageData.pageId,
    });
    bridge.open(pageData.storeLink)
  }
  return;
}
if (!canClick.value) return;
canClick.value = false;
window.activityDataLayer.push({
  eventName: 'click_button',
  eventType: '领取首储奖励',
  gameId: pageData.gameId,
  aid: pageData.pageId,
});
await getFirstGift();
canClick.value = true;
} catch (error) {console.log(error)}
      }
    // 自定义setup - 结束


</script>
<style lang="scss" scoped>
.default{
.u_c_113F49.normal{
position:relative;
width:10.00rem;
height:13.05rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264525-89.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}
}.default{
.u_c_EZY950.normal{
position:relative;
width:9.79rem;
height:2.55rem;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.68rem;
font-size:0.93rem;
color:#e4d749;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_EZY950.normal.text{
width:100%;
height:auto;

}
}.default{
.u_c_9ETL51.normal{
position:relative;

}
}.default{
.u_c_4Y2C52.normal{
position:relative;
margin-top:0.56rem;
line-height:1.5;
box-sizing:border-box;
padding:0 0.27rem;
font-size:0.29rem;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}
}.default{
.u_c_94ZU53.normal{
position:relative;
margin:auto;
margin-top:0.04rem;
background:no-repeat center;
background-size:contain;
width:7.85rem;
height:6.31rem;

}
}.default{
.u_c_GVOB54.normal{
position:relative;
width:5.65rem;
height:1.69rem;
background:no-repeat center;
background-size:contain;
margin:auto;
text-align:center;
text-decoration:none;
margin-top:0.13rem;
display:block;
overflow:hidden;

}

.u_c_GVOB54.normal.has{
filter:grayscale(1);

}
}.default{
.u_c_HGYQ55.normal{
position:relative;
margin:auto;
text-align:center;
margin-top:0.40rem;

}
}.default{
.u_c_67AJ56.normal{
position:relative;

}
}.default{
.u_c_2F1C58.normal{
position:relative;

}
}.default{
.u_c_471C60.normal{
position:relative;

}
}.zh-CN{
.u_c_113F49.normal{
position:relative;
width:10.00rem;
height:13.05rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264525-89.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}
}.zh-CN{
.u_c_EZY950.normal{
position:relative;
width:9.79rem;
height:2.55rem;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.68rem;
font-size:0.93rem;
color:#e4d749;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_EZY950.normal.text{
width:100%;
height:auto;

}
}.zh-CN{
.u_c_9ETL51.normal{
position:relative;

}
}.zh-CN{
.u_c_4Y2C52.normal{
position:relative;
margin-top:0.56rem;
line-height:1.5;
box-sizing:border-box;
padding:0 0.27rem;
font-size:0.29rem;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}
}.zh-CN{
.u_c_94ZU53.normal{
position:relative;
margin:auto;
margin-top:0.04rem;
background:no-repeat center;
background-size:contain;
width:7.85rem;
height:6.31rem;

}
}.zh-CN{
.u_c_GVOB54.normal{
position:relative;
width:5.65rem;
height:1.69rem;
background:no-repeat center;
background-size:contain;
margin:auto;
text-align:center;
text-decoration:none;
margin-top:0.13rem;
display:block;
overflow:hidden;

}

.u_c_GVOB54.normal.has{
filter:grayscale(1);

}
}.zh-CN{
.u_c_HGYQ55.normal{
position:relative;
margin:auto;
text-align:center;
margin-top:0.40rem;

}
}.zh-CN{
.u_c_67AJ56.normal{
position:relative;

}
}.zh-CN{
.u_c_2F1C58.normal{
position:relative;

}
}.zh-CN{
.u_c_471C60.normal{
position:relative;

}
}.zh-TW{
.u_c_113F49.normal{
position:relative;
width:10.00rem;
height:13.05rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264525-89.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}
}.zh-TW{
.u_c_EZY950.normal{
position:relative;
width:9.79rem;
height:2.55rem;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.68rem;
font-size:0.93rem;
color:#e4d749;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_EZY950.normal.text{
width:100%;
height:auto;

}
}.zh-TW{
.u_c_9ETL51.normal{
position:relative;

}
}.zh-TW{
.u_c_4Y2C52.normal{
position:relative;
margin-top:0.56rem;
line-height:1.5;
box-sizing:border-box;
padding:0 0.27rem;
font-size:0.29rem;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}
}.zh-TW{
.u_c_94ZU53.normal{
position:relative;
margin:auto;
margin-top:0.04rem;
background:no-repeat center;
background-size:contain;
width:7.85rem;
height:6.31rem;

}
}.zh-TW{
.u_c_GVOB54.normal{
position:relative;
width:5.65rem;
height:1.69rem;
background:no-repeat center;
background-size:contain;
margin:auto;
text-align:center;
text-decoration:none;
margin-top:0.13rem;
display:block;
overflow:hidden;

}

.u_c_GVOB54.normal.has{
filter:grayscale(1);

}
}.zh-TW{
.u_c_HGYQ55.normal{
position:relative;
margin:auto;
text-align:center;
margin-top:0.40rem;

}
}.zh-TW{
.u_c_67AJ56.normal{
position:relative;

}
}.zh-TW{
.u_c_2F1C58.normal{
position:relative;

}
}.zh-TW{
.u_c_471C60.normal{
position:relative;

}
}.en-US{
.u_c_113F49.normal{
position:relative;
width:10.00rem;
height:13.05rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264525-89.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}
}.en-US{
.u_c_EZY950.normal{
position:relative;
width:9.79rem;
height:2.55rem;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.68rem;
font-size:0.93rem;
color:#e4d749;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_EZY950.normal.text{
width:100%;
height:auto;

}
}.en-US{
.u_c_9ETL51.normal{
position:relative;

}
}.en-US{
.u_c_4Y2C52.normal{
position:relative;
margin-top:0.56rem;
line-height:1.5;
box-sizing:border-box;
padding:0 0.27rem;
font-size:0.29rem;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}
}.en-US{
.u_c_94ZU53.normal{
position:relative;
margin:auto;
margin-top:0.04rem;
background:no-repeat center;
background-size:contain;
width:7.85rem;
height:6.31rem;

}
}.en-US{
.u_c_GVOB54.normal{
position:relative;
width:5.65rem;
height:1.69rem;
background:no-repeat center;
background-size:contain;
margin:auto;
text-align:center;
text-decoration:none;
margin-top:0.13rem;
display:block;
overflow:hidden;

}

.u_c_GVOB54.normal.has{
filter:grayscale(1);

}
}.en-US{
.u_c_HGYQ55.normal{
position:relative;
margin:auto;
text-align:center;
margin-top:0.40rem;

}
}.en-US{
.u_c_67AJ56.normal{
position:relative;

}
}.en-US{
.u_c_2F1C58.normal{
position:relative;

}
}.en-US{
.u_c_471C60.normal{
position:relative;

}
}.ja-JP{
.u_c_113F49.normal{
position:relative;
width:10.00rem;
height:13.05rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264525-89.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}
}.ja-JP{
.u_c_EZY950.normal{
position:relative;
width:9.79rem;
height:2.55rem;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.68rem;
font-size:0.93rem;
color:#e4d749;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_EZY950.normal.text{
width:100%;
height:auto;

}
}.ja-JP{
.u_c_9ETL51.normal{
position:relative;

}
}.ja-JP{
.u_c_4Y2C52.normal{
position:relative;
margin-top:0.56rem;
line-height:1.5;
box-sizing:border-box;
padding:0 0.27rem;
font-size:0.29rem;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}
}.ja-JP{
.u_c_94ZU53.normal{
position:relative;
margin:auto;
margin-top:0.04rem;
background:no-repeat center;
background-size:contain;
width:7.85rem;
height:6.31rem;

}
}.ja-JP{
.u_c_GVOB54.normal{
position:relative;
width:5.65rem;
height:1.69rem;
background:no-repeat center;
background-size:contain;
margin:auto;
text-align:center;
text-decoration:none;
margin-top:0.13rem;
display:block;
overflow:hidden;

}

.u_c_GVOB54.normal.has{
filter:grayscale(1);

}
}.ja-JP{
.u_c_HGYQ55.normal{
position:relative;
margin:auto;
text-align:center;
margin-top:0.40rem;

}
}.ja-JP{
.u_c_67AJ56.normal{
position:relative;

}
}.ja-JP{
.u_c_2F1C58.normal{
position:relative;

}
}.ja-JP{
.u_c_471C60.normal{
position:relative;

}
}.ko-KR{
.u_c_113F49.normal{
position:relative;
width:10.00rem;
height:13.05rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264525-89.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}
}.ko-KR{
.u_c_EZY950.normal{
position:relative;
width:9.79rem;
height:2.55rem;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.68rem;
font-size:0.93rem;
color:#e4d749;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_EZY950.normal.text{
width:100%;
height:auto;

}
}.ko-KR{
.u_c_9ETL51.normal{
position:relative;

}
}.ko-KR{
.u_c_4Y2C52.normal{
position:relative;
margin-top:0.56rem;
line-height:1.5;
box-sizing:border-box;
padding:0 0.27rem;
font-size:0.29rem;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}
}.ko-KR{
.u_c_94ZU53.normal{
position:relative;
margin:auto;
margin-top:0.04rem;
background:no-repeat center;
background-size:contain;
width:7.85rem;
height:6.31rem;

}
}.ko-KR{
.u_c_GVOB54.normal{
position:relative;
width:5.65rem;
height:1.69rem;
background:no-repeat center;
background-size:contain;
margin:auto;
text-align:center;
text-decoration:none;
margin-top:0.13rem;
display:block;
overflow:hidden;

}

.u_c_GVOB54.normal.has{
filter:grayscale(1);

}
}.ko-KR{
.u_c_HGYQ55.normal{
position:relative;
margin:auto;
text-align:center;
margin-top:0.40rem;

}
}.ko-KR{
.u_c_67AJ56.normal{
position:relative;

}
}.ko-KR{
.u_c_2F1C58.normal{
position:relative;

}
}.ko-KR{
.u_c_471C60.normal{
position:relative;

}
}.th-TH{
.u_c_113F49.normal{
position:relative;
width:10.00rem;
height:13.05rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264525-89.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}
}.th-TH{
.u_c_EZY950.normal{
position:relative;
width:9.79rem;
height:2.55rem;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.68rem;
font-size:0.93rem;
color:#e4d749;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_EZY950.normal.text{
width:100%;
height:auto;

}
}.th-TH{
.u_c_9ETL51.normal{
position:relative;

}
}.th-TH{
.u_c_4Y2C52.normal{
position:relative;
margin-top:0.56rem;
line-height:1.5;
box-sizing:border-box;
padding:0 0.27rem;
font-size:0.29rem;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}
}.th-TH{
.u_c_94ZU53.normal{
position:relative;
margin:auto;
margin-top:0.04rem;
background:no-repeat center;
background-size:contain;
width:7.85rem;
height:6.31rem;

}
}.th-TH{
.u_c_GVOB54.normal{
position:relative;
width:5.65rem;
height:1.69rem;
background:no-repeat center;
background-size:contain;
margin:auto;
text-align:center;
text-decoration:none;
margin-top:0.13rem;
display:block;
overflow:hidden;

}

.u_c_GVOB54.normal.has{
filter:grayscale(1);

}
}.th-TH{
.u_c_HGYQ55.normal{
position:relative;
margin:auto;
text-align:center;
margin-top:0.40rem;

}
}.th-TH{
.u_c_67AJ56.normal{
position:relative;

}
}.th-TH{
.u_c_2F1C58.normal{
position:relative;

}
}.th-TH{
.u_c_471C60.normal{
position:relative;

}
}.vi-VN{
.u_c_113F49.normal{
position:relative;
width:10.00rem;
height:13.05rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264525-89.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}
}.vi-VN{
.u_c_EZY950.normal{
position:relative;
width:9.79rem;
height:2.55rem;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.68rem;
font-size:0.93rem;
color:#e4d749;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_EZY950.normal.text{
width:100%;
height:auto;

}
}.vi-VN{
.u_c_9ETL51.normal{
position:relative;

}
}.vi-VN{
.u_c_4Y2C52.normal{
position:relative;
margin-top:0.56rem;
line-height:1.5;
box-sizing:border-box;
padding:0 0.27rem;
font-size:0.29rem;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}
}.vi-VN{
.u_c_94ZU53.normal{
position:relative;
margin:auto;
margin-top:0.04rem;
background:no-repeat center;
background-size:contain;
width:7.85rem;
height:6.31rem;

}
}.vi-VN{
.u_c_GVOB54.normal{
position:relative;
width:5.65rem;
height:1.69rem;
background:no-repeat center;
background-size:contain;
margin:auto;
text-align:center;
text-decoration:none;
margin-top:0.13rem;
display:block;
overflow:hidden;

}

.u_c_GVOB54.normal.has{
filter:grayscale(1);

}
}.vi-VN{
.u_c_HGYQ55.normal{
position:relative;
margin:auto;
text-align:center;
margin-top:0.40rem;

}
}.vi-VN{
.u_c_67AJ56.normal{
position:relative;

}
}.vi-VN{
.u_c_2F1C58.normal{
position:relative;

}
}.vi-VN{
.u_c_471C60.normal{
position:relative;

}
}.de-DE{
.u_c_113F49.normal{
position:relative;
width:10.00rem;
height:13.05rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264525-89.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}
}.de-DE{
.u_c_EZY950.normal{
position:relative;
width:9.79rem;
height:2.55rem;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.68rem;
font-size:0.93rem;
color:#e4d749;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_EZY950.normal.text{
width:100%;
height:auto;

}
}.de-DE{
.u_c_9ETL51.normal{
position:relative;

}
}.de-DE{
.u_c_4Y2C52.normal{
position:relative;
margin-top:0.56rem;
line-height:1.5;
box-sizing:border-box;
padding:0 0.27rem;
font-size:0.29rem;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}
}.de-DE{
.u_c_94ZU53.normal{
position:relative;
margin:auto;
margin-top:0.04rem;
background:no-repeat center;
background-size:contain;
width:7.85rem;
height:6.31rem;

}
}.de-DE{
.u_c_GVOB54.normal{
position:relative;
width:5.65rem;
height:1.69rem;
background:no-repeat center;
background-size:contain;
margin:auto;
text-align:center;
text-decoration:none;
margin-top:0.13rem;
display:block;
overflow:hidden;

}

.u_c_GVOB54.normal.has{
filter:grayscale(1);

}
}.de-DE{
.u_c_HGYQ55.normal{
position:relative;
margin:auto;
text-align:center;
margin-top:0.40rem;

}
}.de-DE{
.u_c_67AJ56.normal{
position:relative;

}
}.de-DE{
.u_c_2F1C58.normal{
position:relative;

}
}.de-DE{
.u_c_471C60.normal{
position:relative;

}
}.fr-FR{
.u_c_113F49.normal{
position:relative;
width:10.00rem;
height:13.05rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264525-89.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}
}.fr-FR{
.u_c_EZY950.normal{
position:relative;
width:9.79rem;
height:2.55rem;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.68rem;
font-size:0.93rem;
color:#e4d749;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_EZY950.normal.text{
width:100%;
height:auto;

}
}.fr-FR{
.u_c_9ETL51.normal{
position:relative;

}
}.fr-FR{
.u_c_4Y2C52.normal{
position:relative;
margin-top:0.56rem;
line-height:1.5;
box-sizing:border-box;
padding:0 0.27rem;
font-size:0.29rem;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}
}.fr-FR{
.u_c_94ZU53.normal{
position:relative;
margin:auto;
margin-top:0.04rem;
background:no-repeat center;
background-size:contain;
width:7.85rem;
height:6.31rem;

}
}.fr-FR{
.u_c_GVOB54.normal{
position:relative;
width:5.65rem;
height:1.69rem;
background:no-repeat center;
background-size:contain;
margin:auto;
text-align:center;
text-decoration:none;
margin-top:0.13rem;
display:block;
overflow:hidden;

}

.u_c_GVOB54.normal.has{
filter:grayscale(1);

}
}.fr-FR{
.u_c_HGYQ55.normal{
position:relative;
margin:auto;
text-align:center;
margin-top:0.40rem;

}
}.fr-FR{
.u_c_67AJ56.normal{
position:relative;

}
}.fr-FR{
.u_c_2F1C58.normal{
position:relative;

}
}.fr-FR{
.u_c_471C60.normal{
position:relative;

}
}.ru-RU{
.u_c_113F49.normal{
position:relative;
width:10.00rem;
height:13.05rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264525-89.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}
}.ru-RU{
.u_c_EZY950.normal{
position:relative;
width:9.79rem;
height:2.55rem;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.68rem;
font-size:0.93rem;
color:#e4d749;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_EZY950.normal.text{
width:100%;
height:auto;

}
}.ru-RU{
.u_c_9ETL51.normal{
position:relative;

}
}.ru-RU{
.u_c_4Y2C52.normal{
position:relative;
margin-top:0.56rem;
line-height:1.5;
box-sizing:border-box;
padding:0 0.27rem;
font-size:0.29rem;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}
}.ru-RU{
.u_c_94ZU53.normal{
position:relative;
margin:auto;
margin-top:0.04rem;
background:no-repeat center;
background-size:contain;
width:7.85rem;
height:6.31rem;

}
}.ru-RU{
.u_c_GVOB54.normal{
position:relative;
width:5.65rem;
height:1.69rem;
background:no-repeat center;
background-size:contain;
margin:auto;
text-align:center;
text-decoration:none;
margin-top:0.13rem;
display:block;
overflow:hidden;

}

.u_c_GVOB54.normal.has{
filter:grayscale(1);

}
}.ru-RU{
.u_c_HGYQ55.normal{
position:relative;
margin:auto;
text-align:center;
margin-top:0.40rem;

}
}.ru-RU{
.u_c_67AJ56.normal{
position:relative;

}
}.ru-RU{
.u_c_2F1C58.normal{
position:relative;

}
}.ru-RU{
.u_c_471C60.normal{
position:relative;

}
}.es-ES{
.u_c_113F49.normal{
position:relative;
width:10.00rem;
height:13.05rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264525-89.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}
}.es-ES{
.u_c_EZY950.normal{
position:relative;
width:9.79rem;
height:2.55rem;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.68rem;
font-size:0.93rem;
color:#e4d749;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_EZY950.normal.text{
width:100%;
height:auto;

}
}.es-ES{
.u_c_9ETL51.normal{
position:relative;

}
}.es-ES{
.u_c_4Y2C52.normal{
position:relative;
margin-top:0.56rem;
line-height:1.5;
box-sizing:border-box;
padding:0 0.27rem;
font-size:0.29rem;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}
}.es-ES{
.u_c_94ZU53.normal{
position:relative;
margin:auto;
margin-top:0.04rem;
background:no-repeat center;
background-size:contain;
width:7.85rem;
height:6.31rem;

}
}.es-ES{
.u_c_GVOB54.normal{
position:relative;
width:5.65rem;
height:1.69rem;
background:no-repeat center;
background-size:contain;
margin:auto;
text-align:center;
text-decoration:none;
margin-top:0.13rem;
display:block;
overflow:hidden;

}

.u_c_GVOB54.normal.has{
filter:grayscale(1);

}
}.es-ES{
.u_c_HGYQ55.normal{
position:relative;
margin:auto;
text-align:center;
margin-top:0.40rem;

}
}.es-ES{
.u_c_67AJ56.normal{
position:relative;

}
}.es-ES{
.u_c_2F1C58.normal{
position:relative;

}
}.es-ES{
.u_c_471C60.normal{
position:relative;

}
}.pt-PT{
.u_c_113F49.normal{
position:relative;
width:10.00rem;
height:13.05rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264525-89.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}
}.pt-PT{
.u_c_EZY950.normal{
position:relative;
width:9.79rem;
height:2.55rem;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.68rem;
font-size:0.93rem;
color:#e4d749;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_EZY950.normal.text{
width:100%;
height:auto;

}
}.pt-PT{
.u_c_9ETL51.normal{
position:relative;

}
}.pt-PT{
.u_c_4Y2C52.normal{
position:relative;
margin-top:0.56rem;
line-height:1.5;
box-sizing:border-box;
padding:0 0.27rem;
font-size:0.29rem;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}
}.pt-PT{
.u_c_94ZU53.normal{
position:relative;
margin:auto;
margin-top:0.04rem;
background:no-repeat center;
background-size:contain;
width:7.85rem;
height:6.31rem;

}
}.pt-PT{
.u_c_GVOB54.normal{
position:relative;
width:5.65rem;
height:1.69rem;
background:no-repeat center;
background-size:contain;
margin:auto;
text-align:center;
text-decoration:none;
margin-top:0.13rem;
display:block;
overflow:hidden;

}

.u_c_GVOB54.normal.has{
filter:grayscale(1);

}
}.pt-PT{
.u_c_HGYQ55.normal{
position:relative;
margin:auto;
text-align:center;
margin-top:0.40rem;

}
}.pt-PT{
.u_c_67AJ56.normal{
position:relative;

}
}.pt-PT{
.u_c_2F1C58.normal{
position:relative;

}
}.pt-PT{
.u_c_471C60.normal{
position:relative;

}
}.it-IT{
.u_c_113F49.normal{
position:relative;
width:10.00rem;
height:13.05rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264525-89.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}
}.it-IT{
.u_c_EZY950.normal{
position:relative;
width:9.79rem;
height:2.55rem;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.68rem;
font-size:0.93rem;
color:#e4d749;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_EZY950.normal.text{
width:100%;
height:auto;

}
}.it-IT{
.u_c_9ETL51.normal{
position:relative;

}
}.it-IT{
.u_c_4Y2C52.normal{
position:relative;
margin-top:0.56rem;
line-height:1.5;
box-sizing:border-box;
padding:0 0.27rem;
font-size:0.29rem;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}
}.it-IT{
.u_c_94ZU53.normal{
position:relative;
margin:auto;
margin-top:0.04rem;
background:no-repeat center;
background-size:contain;
width:7.85rem;
height:6.31rem;

}
}.it-IT{
.u_c_GVOB54.normal{
position:relative;
width:5.65rem;
height:1.69rem;
background:no-repeat center;
background-size:contain;
margin:auto;
text-align:center;
text-decoration:none;
margin-top:0.13rem;
display:block;
overflow:hidden;

}

.u_c_GVOB54.normal.has{
filter:grayscale(1);

}
}.it-IT{
.u_c_HGYQ55.normal{
position:relative;
margin:auto;
text-align:center;
margin-top:0.40rem;

}
}.it-IT{
.u_c_67AJ56.normal{
position:relative;

}
}.it-IT{
.u_c_2F1C58.normal{
position:relative;

}
}.it-IT{
.u_c_471C60.normal{
position:relative;

}
}.tr-TR{
.u_c_113F49.normal{
position:relative;
width:10.00rem;
height:13.05rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264525-89.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}
}.tr-TR{
.u_c_EZY950.normal{
position:relative;
width:9.79rem;
height:2.55rem;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.68rem;
font-size:0.93rem;
color:#e4d749;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_EZY950.normal.text{
width:100%;
height:auto;

}
}.tr-TR{
.u_c_9ETL51.normal{
position:relative;

}
}.tr-TR{
.u_c_4Y2C52.normal{
position:relative;
margin-top:0.56rem;
line-height:1.5;
box-sizing:border-box;
padding:0 0.27rem;
font-size:0.29rem;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}
}.tr-TR{
.u_c_94ZU53.normal{
position:relative;
margin:auto;
margin-top:0.04rem;
background:no-repeat center;
background-size:contain;
width:7.85rem;
height:6.31rem;

}
}.tr-TR{
.u_c_GVOB54.normal{
position:relative;
width:5.65rem;
height:1.69rem;
background:no-repeat center;
background-size:contain;
margin:auto;
text-align:center;
text-decoration:none;
margin-top:0.13rem;
display:block;
overflow:hidden;

}

.u_c_GVOB54.normal.has{
filter:grayscale(1);

}
}.tr-TR{
.u_c_HGYQ55.normal{
position:relative;
margin:auto;
text-align:center;
margin-top:0.40rem;

}
}.tr-TR{
.u_c_67AJ56.normal{
position:relative;

}
}.tr-TR{
.u_c_2F1C58.normal{
position:relative;

}
}.tr-TR{
.u_c_471C60.normal{
position:relative;

}
}.pl-PL{
.u_c_113F49.normal{
position:relative;
width:10.00rem;
height:13.05rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264525-89.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}
}.pl-PL{
.u_c_EZY950.normal{
position:relative;
width:9.79rem;
height:2.55rem;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.68rem;
font-size:0.93rem;
color:#e4d749;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_EZY950.normal.text{
width:100%;
height:auto;

}
}.pl-PL{
.u_c_9ETL51.normal{
position:relative;

}
}.pl-PL{
.u_c_4Y2C52.normal{
position:relative;
margin-top:0.56rem;
line-height:1.5;
box-sizing:border-box;
padding:0 0.27rem;
font-size:0.29rem;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}
}.pl-PL{
.u_c_94ZU53.normal{
position:relative;
margin:auto;
margin-top:0.04rem;
background:no-repeat center;
background-size:contain;
width:7.85rem;
height:6.31rem;

}
}.pl-PL{
.u_c_GVOB54.normal{
position:relative;
width:5.65rem;
height:1.69rem;
background:no-repeat center;
background-size:contain;
margin:auto;
text-align:center;
text-decoration:none;
margin-top:0.13rem;
display:block;
overflow:hidden;

}

.u_c_GVOB54.normal.has{
filter:grayscale(1);

}
}.pl-PL{
.u_c_HGYQ55.normal{
position:relative;
margin:auto;
text-align:center;
margin-top:0.40rem;

}
}.pl-PL{
.u_c_67AJ56.normal{
position:relative;

}
}.pl-PL{
.u_c_2F1C58.normal{
position:relative;

}
}.pl-PL{
.u_c_471C60.normal{
position:relative;

}
}.id-ID{
.u_c_113F49.normal{
position:relative;
width:10.00rem;
height:13.05rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264525-89.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}
}.id-ID{
.u_c_EZY950.normal{
position:relative;
width:9.79rem;
height:2.55rem;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.68rem;
font-size:0.93rem;
color:#e4d749;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_EZY950.normal.text{
width:100%;
height:auto;

}
}.id-ID{
.u_c_9ETL51.normal{
position:relative;

}
}.id-ID{
.u_c_4Y2C52.normal{
position:relative;
margin-top:0.56rem;
line-height:1.5;
box-sizing:border-box;
padding:0 0.27rem;
font-size:0.29rem;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}
}.id-ID{
.u_c_94ZU53.normal{
position:relative;
margin:auto;
margin-top:0.04rem;
background:no-repeat center;
background-size:contain;
width:7.85rem;
height:6.31rem;

}
}.id-ID{
.u_c_GVOB54.normal{
position:relative;
width:5.65rem;
height:1.69rem;
background:no-repeat center;
background-size:contain;
margin:auto;
text-align:center;
text-decoration:none;
margin-top:0.13rem;
display:block;
overflow:hidden;

}

.u_c_GVOB54.normal.has{
filter:grayscale(1);

}
}.id-ID{
.u_c_HGYQ55.normal{
position:relative;
margin:auto;
text-align:center;
margin-top:0.40rem;

}
}.id-ID{
.u_c_67AJ56.normal{
position:relative;

}
}.id-ID{
.u_c_2F1C58.normal{
position:relative;

}
}.id-ID{
.u_c_471C60.normal{
position:relative;

}
}.ar-SA{
.u_c_113F49.normal{
position:relative;
width:10.00rem;
height:13.05rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1721186264525-89.jpeg);
overflow:hidden;
font-size:0;
margin:auto;

}
}.ar-SA{
.u_c_EZY950.normal{
position:relative;
width:9.79rem;
height:2.55rem;
background:no-repeat center;
background-size:contain;
margin:auto;
margin-top:0.68rem;
font-size:0.93rem;
color:#e4d749;
text-align:center;
font-weight:bold;
white-space:pre-wrap;
line-height:1.2;

}

.u_c_EZY950.normal.text{
width:100%;
height:auto;

}
}.ar-SA{
.u_c_9ETL51.normal{
position:relative;

}
}.ar-SA{
.u_c_4Y2C52.normal{
position:relative;
margin-top:0.56rem;
line-height:1.5;
box-sizing:border-box;
padding:0 0.27rem;
font-size:0.29rem;
color:#ffffff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;

}
}.ar-SA{
.u_c_94ZU53.normal{
position:relative;
margin:auto;
margin-top:0.04rem;
background:no-repeat center;
background-size:contain;
width:7.85rem;
height:6.31rem;

}
}.ar-SA{
.u_c_GVOB54.normal{
position:relative;
width:5.65rem;
height:1.69rem;
background:no-repeat center;
background-size:contain;
margin:auto;
text-align:center;
text-decoration:none;
margin-top:0.13rem;
display:block;
overflow:hidden;

}

.u_c_GVOB54.normal.has{
filter:grayscale(1);

}
}.ar-SA{
.u_c_HGYQ55.normal{
position:relative;
margin:auto;
text-align:center;
margin-top:0.40rem;

}
}.ar-SA{
.u_c_67AJ56.normal{
position:relative;

}
}.ar-SA{
.u_c_2F1C58.normal{
position:relative;

}
}.ar-SA{
.u_c_471C60.normal{
position:relative;

}
}
</style>
